import React from "react"
import {
  Col,
  InputNumber,
  Select,
  Divider,
  Typography,
  Input,
  Button,
  Switch,
  Slider,
  Row,
} from "antd" // import necessary components from antd
import { CheckCircleFilled, ClearOutlined, CloseCircleOutlined } from "@ant-design/icons" // import necessary icons from antd

const { Option } = Select
const { Text } = Typography
const { TextArea } = Input

export default function FlexoFields({
  selectedKnifeCode,
  CalculationsPopup,
  selectedMachine,
  setNumberOfColumns,
  machineAlsm,
  setKniveSpaceBetweenRows,
  setLabelWidth,
  setLabelHeight,
  setSelectedKnifeCode,
  setSelectedKnifeId,
  setKniveButtonText,
  kniveButtonText,
  setNewKnife,
  setKnifePrice,
  setKnifeShape,
  knifeShape,
  clearKnives,
  labelWidth,
  handleLabelWidth,
  labelHeight,
  handleLabelHeight,
  selectedMaterial,
  handleMaterial,
  materialLoading,
  material,
  formatWidth,
  handleFormatWidth,
  formatWidthList,
  numberOfColumns,
  handleNumberOfColumns,
  newKnife,
  rowBalance,
  tooltipRowBalance,
  userComment,
  setUserComment,
  visible,
  extraProfitSlider,
  setExtraProfitSlider,
  changableSpace,
  setChangableSpace,
  fixedPrice,
  handleFixedPrice,
  totalFixedPrice,
  setTotalFixedPrice,
  disableFixedPriceButton,
  dynamicFixedPrice,
  handleAmountChangeFixed,
  removeAmountFieldsFixed,
  handleAddAmountFixed,
  setVisible,
  newKnifeMessage,
  setNewKnifeMessage,
  newKnifeRadiuss,
  setNewKnifeRadius,
  setNewKnifeFile,
  setKniveGapRaport,
}) {
  return (
    <>
      <Col span={10}>
        <Text>
          Knives{" "}
          {selectedKnifeCode === "none" ? "" : <CheckCircleFilled style={{ color: "green" }} />}
        </Text>
      </Col>
      <Col span={kniveButtonText === "Select" ? 14 : 12}>
        <CalculationsPopup
          selectedMachine={selectedMachine}
          setNumberOfColumns={setNumberOfColumns}
          machineAlsm={machineAlsm}
          setKniveSpaceBetweenRows={setKniveSpaceBetweenRows}
          setLabelWidth={setLabelWidth}
          setLabelHeight={setLabelHeight}
          setSelectedKnifeCode={setSelectedKnifeCode}
          setSelectedKnifeId={setSelectedKnifeId}
          setKniveButtonText={setKniveButtonText}
          kniveButtonText={kniveButtonText}
          setNewKnife={setNewKnife}
          setKnifePrice={setKnifePrice}
          setKnifeShape={setKnifeShape}
          knifeShape={knifeShape}
          newKnifeMessage={newKnifeMessage}
          setNewKnifeMessage={setNewKnifeMessage}
          newKnifeRadiuss={newKnifeRadiuss}
          setNewKnifeRadius={setNewKnifeRadius}
          setNewKnifeFile={setNewKnifeFile}
          setKniveGapRaport={setKniveGapRaport}
        />
      </Col>
      {kniveButtonText === "Select" ? (
        ""
      ) : (
        <Col span={2}>
          <ClearOutlined onClick={() => clearKnives()} style={{ marginLeft: "5px" }} />
        </Col>
      )}

      <Col span={10}>
        <Text>
          Label width {labelWidth <= 0 ? "" : <CheckCircleFilled style={{ color: "green" }} />}
        </Text>
      </Col>
      <Col span={14}>
        <InputNumber
          disabled
          value={labelWidth}
          min={0}
          onChange={handleLabelWidth}
          placeholder="Label width"
          style={{ width: "100%" }}
        />
      </Col>

      <Col span={10}>
        <Text>
          Label height {labelHeight <= 0 ? "" : <CheckCircleFilled style={{ color: "green" }} />}
        </Text>
      </Col>
      <Col span={14}>
        <InputNumber
          disabled
          value={labelHeight}
          min={0}
          onChange={handleLabelHeight}
          placeholder="Height"
          style={{ width: "100%" }}
        />
      </Col>

      <Col span={8}>
        <Text>
          Material{" "}
          {selectedMaterial === "none" ? "" : <CheckCircleFilled style={{ color: "green" }} />}
        </Text>
      </Col>
      <Col span={16}>
        <Select
          onChange={handleMaterial}
          loading={materialLoading}
          value={selectedMaterial && selectedMaterial}
          style={{ width: "100%" }}
          placeholder="Material"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
          }>
          {material &&
            material.map((material, id) => (
              <Option
                eurM2={material.eurM2}
                widths={material.widths}
                gM2={material.gM2}
                id={material.id}
                key={id}
                value={material.material}>
                {material.material}
              </Option>
            ))}
        </Select>
      </Col>
      <Col span={8}>
        <Text>
          Format
          {formatWidth <= 0 ? (
            ""
          ) : <CheckCircleFilled style={{ color: "green" }} /> && numberOfColumns <= 0 ? (
            ""
          ) : (
            <CheckCircleFilled style={{ color: "green", marginLeft: "2px" }} />
          )}
        </Text>
      </Col>
      <Col span={8}>
        {/* <InputNumber min={0} value={formatWidth} onChange={(value) => setFormatWidth(value)} placeholder="Width" style={{ width: "100%" }} /> */}
        <Select
          style={{
            width: "100%",
          }}
          value={formatWidth && formatWidth}
          onChange={handleFormatWidth}>
          {formatWidthList &&
            formatWidthList.map((res, index) => (
              <Option key={index} value={res}>
                {res}
              </Option>
            ))}
        </Select>
      </Col>
      <Col span={8}>
        <InputNumber
          min={0}
          value={numberOfColumns}
          onChange={handleNumberOfColumns}
          placeholder="Nr.of columns"
          style={{ width: "100%" }}
        />
      </Col>

      <Col span={8}>Row Balance</Col>
      <Col span={16}>
        <InputNumber
          disabled
          value={rowBalance}
          precision={2}
          placeholder="Row balance"
          style={{ width: "100%" }}
        />
      </Col>
      {tooltipRowBalance ? (
        <>
          <Col span={24}>
            <Text style={{ fontSize: "12px" }} italic type="danger">
              Row Balance stands for "excess material". This means that if Row Balance number is
              higher than 10, you are wasting material. If the Row balance is with negative value,
              you will not be able to print!
            </Text>
            <br />
            <br />
            <Text style={{ fontSize: "12px" }} italic type="danger">
              If the row balance is -5 or more, you wont be able to save the price.
            </Text>
          </Col>
        </>
      ) : (
        ""
      )}

      <Col span={24}>
        <Divider>Comment</Divider>
        <TextArea
          showCount
          value={userComment && userComment}
          style={{
            height: 90,
            marginBottom: 24,
            allowClear: true,
          }}
          onChange={(e) => setUserComment(e.target.value)}
          placeholder="Add a comment"
        />
      </Col>
      <Divider />
      <Col flex="auto">
        <Text>Show Advanced settings</Text>
      </Col>
      <Col flex="30px">
        <Switch
          checked={visible}
          size="default"
          checkedChildren="ON"
          unCheckedChildren="OFF"
          onChange={() => setVisible(!visible)}
        />
      </Col>
      {/* ADVANCED FEATURES FOR PRICE CALULCATION */}
      {visible ? (
        <>
          <Divider>Advanced Settings</Divider>

          <Col span={10}>Profit Slider</Col>
          <Col span={10}>
            <Slider
              value={extraProfitSlider && extraProfitSlider}
              included={false}
              //   tooltip={{ formatter }}
              defaultValue={0}
              min={-10}
              max={10}
              onChange={(value) => setExtraProfitSlider(value)}
            />
          </Col>

          <Col flex="auto">
            <Text>{extraProfitSlider + "%"}</Text>
          </Col>

          <Col span={10}>Changable Space</Col>
          <Col span={7}>
            <Switch checked={changableSpace} onChange={setChangableSpace} />
          </Col>
          <Col span={10}>Fixed Price</Col>
          <Col span={7}>
            <Switch checked={fixedPrice} onChange={handleFixedPrice} />
          </Col>
          {fixedPrice === true ? (
            <>
              <Divider>Fixed Dynamic Price</Divider>
              {dynamicFixedPrice && dynamicFixedPrice.length !== 0 ? (
                <>
                  <Col flex="42%">
                    <Text>Count</Text>
                  </Col>
                  <Col flex="58%">
                    <Text>Price</Text>
                  </Col>
                </>
              ) : (
                ""
              )}
              {dynamicFixedPrice && dynamicFixedPrice.length !== 0
                ? dynamicFixedPrice.map((inputField, index) => (
                    <div key={index}>
                      <Row justify="end" align="middle">
                        <Col span={20}>
                          <Input.Group compact>
                            <InputNumber
                              style={{ width: "50%" }}
                              min={0}
                              value={inputField.quantity}
                              onChange={(value) =>
                                handleAmountChangeFixed(index, "quantity", value)
                              }
                            />
                            <InputNumber
                              style={{ width: "50%" }}
                              min={0}
                              step={0.01}
                              value={inputField.price}
                              onChange={(value) => handleAmountChangeFixed(index, "price", value)}
                            />
                          </Input.Group>
                        </Col>
                        <Col span={4}>
                          <Button
                            type="primary"
                            ghost
                            danger
                            onClick={() => removeAmountFieldsFixed(index)}>
                            <CloseCircleOutlined />
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  ))
                : ""}

              <Button type="primary" block onClick={() => handleAddAmountFixed()}>
                Add More Fixed
              </Button>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
    </>
  )
}
